import fetchClient from '../api/api-client'

export const getCurrencyObj = async () => {
  try {
    const res = await fetchClient.get('/dollarCurrency')
    // console.log("getCurrencyObj - res", res)

    return res.data.data
  } catch (error) {
    console.log('getCurrencyObj - error', error)
  }
}

export const updateCurrencyObj = async (id, body) => {
  try {
    return await fetchClient.patch(`/dollarCurrency/${id}`, body)
  } catch (error) {
    console.log('updateCurrencyObj - error', error)
  }
}
